<template>
    <div class="indicator-ball">
        <div class="indicator-ball__outer-circle" :class="`bg-color-${variant}-light`">
            <div class="indicator-ball__inner-circle" :class="`bg-color-${variant}`">
                <div class="indicator-ball__content">
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'indicatorBall',
    props: {
        variant: {
            type: String,
            default: 'bq-green'
        }
    }
}
</script>
<style lang="scss">
    .indicator-ball__outer-circle {
        border-radius: 50%;
        width: 120px;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .indicator-ball__inner-circle {
        border-radius: 50%;
        width: 90px;
        height: 90px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .indicator-ball__content {
        color: white;
        font-weight: bold;
    }
</style>